export const CHECK_TYPE_MAX_LENGTH = 100;
export const SCOPE_OF_REVIEW_MAX_LENGTH = 5000;
export const COMMENTS_MAX_LENGTH = 5000;
export const DELIVERABLE_KEYWORDS_MAX_LENGTH = 200;

export class ChecksRoutes {
  static readonly MANDATORY_CHECKS = 'mandatory-checks';
  static readonly ADDITIONAL_CHECKS = 'additional-checks';
}
